export const requireAll = (r) => {
  r.keys().forEach(r);
};
